import { useState } from 'react';
import { Mitteilungen } from '../api/apiClient';
import { formatZeitraum } from '../utils/format';

/**
 * Zeitraum, Ort und Kalender-Download eines Termins.
 * Bei einer Mitteilung (kein Termin) wird nichts ausgegeben.
 */
function MitteilungTerminInfo({ mitteilung, onFehler, ohneIcal = false }) {
  const [ladend, setLadend] = useState(false);

  if (mitteilung?.art !== 'termin' || !mitteilung?.beginn) return null;

  const handleIcal = async () => {
    setLadend(true);
    try {
      await Mitteilungen.downloadIcal(mitteilung.mitteilungsId, mitteilung.titel);
    } catch (e) {
      onFehler?.(`Kalenderdatei konnte nicht geladen werden: ${e.message}`);
    } finally {
      setLadend(false);
    }
  };

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5">
      <div className="flex items-start gap-2 text-sm text-slate-700">
        <CalendarIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />
        <div className="min-w-0 flex-1">
          <p className="font-medium">
            {formatZeitraum(mitteilung.beginn, mitteilung.ende, mitteilung.ganztaegig)}
          </p>
          {mitteilung.ort && (
            <p className="mt-0.5 flex items-start gap-1.5 text-slate-600">
              <LocationIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-400" />
              <span className="min-w-0">{mitteilung.ort}</span>
            </p>
          )}
        </div>
        {!ohneIcal && (
          <button
            type="button"
            onClick={handleIcal}
            disabled={ladend}
            className="btn btn-ghost btn-sm shrink-0 gap-1.5"
            title="Termin in den Kalender übernehmen (.ics)"
          >
            <DownloadIcon className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{ladend ? 'Wird geladen…' : 'Kalender'}</span>
          </button>
        )}
      </div>
    </div>
  );
}

function CalendarIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function LocationIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 13 6 13s6-7.75 6-13c0-3.314-2.686-6-6-6z" />
      <circle cx="12" cy="8" r="2" />
    </svg>
  );
}

function DownloadIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}

export default MitteilungTerminInfo;
